import { LitElement, svg } from 'lit';

class Icon extends LitElement {
	static get properties() {
		return {
			icon: { type: String },
			size: { type: String },
		};
	}

	constructor() {
		super();

		this.size = 's';
		this.icon = '';
	}

	render() {
		const href = `/icons/sprite.svg#${this.icon}`;

		return svg`
			<svg viewBox="0 0 16 16" class="icon icon--${this.size}">
				 <use href=${href}></use>
			</svg>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-icon', Icon);

export default Icon;
